import { Component, OnInit } from "@angular/core";

@Component({
  selector: "app-import-datos-accesorios",
  templateUrl: "./import-datos-accesorios.component.html",
  // styleUrls: ["./import-datos-accesorios.component.sass"],
})
export class ImportDatosAccesoriosComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
